module.exports = __webpack_public_path__ + "img/yhbd-img.9673a646.png";